import $ from 'jquery';

//Offcanvas searchbar
let offCanvasSearchField = $( '.navigation__utility-search-input' );
let navigationUtilitySearchButton = $( '.navigation__utility-search-button' );
const $navigation = $( '.navigation' );
const $offCanvasTop = $( '#offCanvasTop' );

$( '#navigation__utility-search--expand' ).on('click', function () {
	if ( offCanvasSearchField.is( ':hidden' ) ) {
		offCanvasSearchField.animate( { width: 'toggle' }, 'fast' );
		navigationUtilitySearchButton.show();
	}
} );

$( '.navigation__utility-shop--close' ).on('click', function (e) {
	if ( offCanvasSearchField.is( ':visible' ) ) {
		e.preventDefault();
		e.stopImmediatePropagation();
		offCanvasSearchField.animate( { width: 'toggle' }, 'fast' );
		navigationUtilitySearchButton.hide();
	}
} );

$( '.navigation-overlay' ).on( 'click', () => {
	hideNavigation();
});

$( window ).on( "resize", function() {
	if ( $navigation.hasClass( 'active' ) && window.innerWidth <= 1023 ) {
		hideNavigation();
	} else if (  window.innerWidth >= 1023 ) {
		$offCanvasTop.foundation('close')
	}
} );

//Desktop navigation:
$( '.show-navigation' ).on( 'click', function () {
	if ( $navigation.hasClass( 'active' ) ) {
		hideNavigation();
	} else {
		$( '.navigation-overlay' ).show();
		$( '.show-navigation' ).css('background-color', '#E7F1FC')

		$navigation.animate( {
			marginTop: 147,
		}, 'fast' );

		$navigation.addClass( 'active' );
	}
} );

const hideNavigation = () => {
	$( '.navigation-overlay' ).hide();
	$( '.show-navigation' ).css('background-color', 'unset')
	$navigation.animate( {
		marginTop: '-100%',
	}, 'fast' );

	$navigation.removeClass( 'active' );

	// on modal close return width to 0
	$( '.sub-menu' ).each( function() {
		$(this).removeClass( 'sub-menu--is-active' );
	});

	$( '.navigation__menu' ).css( {
		width: '',
	});
}

$( '.menu-item-has-children' ).on( 'mouseenter', function ( e ) {
	// if sub-item is clicked stay max width
	let isActive = false;

	$( '.sub-menu' ).each( function () {
		if ( $( this ).hasClass( 'sub-menu--is-active' ) ) {
			isActive = true
		}
	} )

	if ( isActive ) {
		return;
	}

	let subMenuWidth = $( this ).children( '.sub-menu' ).width();
	let menu = $( '.navigation__menu' );
	let width = menu.width();


} );

// onclick stay active
$( '.menu-item-has-children' ).on( 'click', function (e) {
	$( '.sub-menu' ).each( function() {
		$(this).removeClass( 'sub-menu--is-active' );
	})

	$( this ).children( '.sub-menu' ).addClass('sub-menu--is-active');
} );


$( '.menu-item-has-children' ).on( 'mouseleave', function () {
	// if sub-item is active stay same width
	let isActive = false;

	$( '.sub-menu' ).each( function () {
		if ( $( this ).hasClass( 'sub-menu--is-active' ) ) {
			isActive = true
		}
	} )

	if ( isActive ) {
		return;
	}

	$( '.navigation__menu' ).css( {
		width: '',
	} );
} );